import dashboardApi from '@/api/dashboard';

const state = {
  filters: {
    periode: {
      type: 'campagne', // 'journalier', 'hebdo', 'campagne', 'custom'
      date_debut: null,
      date_fin: null,
    },
    niveau: {
      type: 'total', // 'total', 'antenne', 'ci', 'producteur', 'groupement'
      id: null,
      label: null,
    },
    cultures: [], // Array d'IDs de produits
    certification: 'toutes', // 'bio', 'non_bio', 'toutes'
  },
  filterOptions: {
    periodes: {},
    niveaux: {},
    cultures: [],
    certifications: {},
    producteurs: [], // Producteurs chargés dynamiquement
  },
  loading: false,
};

const mutations = {
  SET_FILTER(state, { filterName, value }) {
    state.filters[filterName] = value;
  },
  SET_FILTER_OPTIONS(state, { optionName, value }) {
    state.filterOptions[optionName] = value;
  },
  RESET_FILTERS(state) {
    state.filters = {
      periode: {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      },
      niveau: {
        type: 'total',
        id: null,
        label: null,
      },
      cultures: [],
      certification: 'toutes',
    };
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  async loadFilterOptions({ commit }) {
    try {
      commit('SET_LOADING', true);

      // Charger toutes les options en parallèle
      const [periodes, niveaux, cultures, certifications] = await Promise.all([
        dashboardApi.getPeriodFilters().catch(err => {
          console.error('Erreur chargement périodes:', err);
          return { data: {}};
        }),
        dashboardApi.getNiveauFilters().catch(err => {
          console.error('Erreur chargement niveaux:', err);
          return { data: {}};
        }),
        dashboardApi.getCultureFilters().catch(err => {
          console.error('Erreur chargement cultures:', err);
          return { data: [] };
        }),
        dashboardApi.getCertificationFilters().catch(err => {
          console.error('Erreur chargement certifications:', err);
          return { data: {}};
        }),
      ]);

      commit('SET_FILTER_OPTIONS', { optionName: 'periodes', value: periodes.data || {}});
      commit('SET_FILTER_OPTIONS', { optionName: 'niveaux', value: niveaux.data || {}});
      commit('SET_FILTER_OPTIONS', { optionName: 'cultures', value: cultures.data || [] });
      commit('SET_FILTER_OPTIONS', { optionName: 'certifications', value: certifications.data || {}});
    } catch (error) {
      console.error('Erreur lors du chargement des options de filtres:', error);
      // Initialiser avec des valeurs par défaut en cas d'erreur
      commit('SET_FILTER_OPTIONS', { optionName: 'periodes', value: {}});
      commit('SET_FILTER_OPTIONS', { optionName: 'niveaux', value: {}});
      commit('SET_FILTER_OPTIONS', { optionName: 'cultures', value: [] });
      commit('SET_FILTER_OPTIONS', { optionName: 'certifications', value: {}});
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async loadProducteurs({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true);
      const response = await dashboardApi.getProducteursFilters(filters);
      const producteurs = response.data || [];

      // Mettre à jour les options de niveau pour les producteurs
      commit('SET_FILTER_OPTIONS', {
        optionName: 'producteurs',
        value: producteurs,
      });

      return producteurs;
    } catch (error) {
      console.error('Erreur lors du chargement des producteurs:', error);
      return [];
    } finally {
      commit('SET_LOADING', false);
    }
  },

  updateFilter({ commit }, { filterName, value }) {
    commit('SET_FILTER', { filterName, value });
  },

  resetFilters({ commit }) {
    commit('RESET_FILTERS');
  },
};

const getters = {
  filters: (state) => state.filters,
  filterOptions: (state) => state.filterOptions,
  isLoading: (state) => state.loading,
  activeFilters: (state) => {
    const filters = { ...state.filters };
    // Nettoyer les filtres null/undefined
    if (!filters.niveau.id) {
      filters.niveau = { type: filters.niveau.type, id: null, label: null };
    }
    return filters;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

